import { ref } from "vue";
import { defineStore } from "pinia";

export default defineStore("language", () => {
  const language = ref<string>("de");

  const setLanguage = (newLanguage: string) => {
    language.value = newLanguage;
  };

  return {
    language,
    setLanguage,
  };
});
